import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const ProfileDetails = {
  fetchProfileDetails: async (userId) => {
    try {
      const response = await axiosInstance.get(Configs.userDetailsEp, {
        params: { user_id: userId },
      });

      if (response.status === 200) {
        const data = response.data;
        const details = data.details;
        // console.log("Fetched user details:", details);

        return {
          name: `${details.first_name} ${details.other_names || ""}`.trim(),
          pseudo_name: details.pseudo_name,
          gender: details.gender,
          age: details.age,
          account: details.account,
          seeking_age_min: details.seeking_age_min,
          seeking_age_max: details.seeking_age_max,
          country_iso_two: details.country,
          location: `${details.country_name}`.trim(),
          area_name: details.area_name,
          aboutMe: details.about_me,
          profile_image: `${Configs.baseUrl}${details.profile_pic}`,
          has_profile_photo: details.profile_pic !== "none",
          photos_hidden: details.photos_hidden === "yes",
          show_photos_to_anonymous: details.show_photos_to_anonymous === "yes",
          hide_photos_from_countrymates:
            details.hide_photos_from_countrymates === "yes",
          interests: data.interests_list || [],
          preferences: details.preferences || [],
          subscription_days: details.subscription_days,
          photos: data.my_pics.map((pic) => ({
            id: pic.photo_id,
            url: `${Configs.baseUrl}${pic.photo_url}`,
          })),
          social_media: data.social_media,
        };
      } else {
        console.error("Failed to load user details:", response.status);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      return null;
    }
  },
};

export default ProfileDetails;
